import { useEffect, useState } from "react";
import axiosInstance from "../AxiosInstance";
import { useTranslation } from "react-i18next";

const Gallery = () => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ Loading state
  const { t } = useTranslation();

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const response = await axiosInstance.get("/files/page/GALLERY");
        const galleryPhotos = response.data
          //.filter(photo => photo.page === "GALLERY")
          .sort((a, b) => new Date(b.date) - new Date(a.date));
        setPhotos(galleryPhotos);
      } catch (error) {
        console.error("Failed to fetch photos:", error);
      } finally {
        setLoading(false); // ✅ Hide spinner after fetch
      }
    };

    fetchPhotos();
  }, []);

  return (
    <div className="mt-10 tracking-wide">
      <h2 className="text-3xl sm:text-5xl lg:text-6xl text-center my-10 bg-gradient-to-r from-blue-500 to-orange-800 text-transparent bg-clip-text mb-6">
        {t("gallery.title")}
      </h2>

      {loading ? (
        <div className="flex justify-center items-center h-[300px]">
          <div className="w-12 h-12 border-4 border-dashed rounded-full animate-spin border-blue-600 border-t-transparent"></div>
        </div>
      ) : (
        <div className="flex flex-wrap justify-center mb-3">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
            {photos.map((photo, index) => (
              <div
                key={index}
                className="relative w-full aspect-square overflow-hidden group"
              >
                <img
                  className="w-full h-full object-cover"
                  src={photo.photoUrl}
                  alt={`gallery-${index}`}
                />
                {/* Hover overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-white text-center text-lg font-semibold px-2">
                    {photo.name || "Untitled"}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
